import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ConfirmXmlService', ConfirmXmlService);

  ConfirmXmlService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'FileSaver',
  ];

  function ConfirmXmlService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    SessionService,
    FileSaver
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'confirm_xmls';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getConfirmXmls: getConfirmXmls,
      getConfirmXml: getConfirmXml,
      saveConfirmXml: saveConfirmXml,
      createBillFromXml: createBillFromXml,
      deleteConfirmXml: deleteConfirmXml,
      changeConfirmXmlStatus: changeConfirmXmlStatus,
      downloadConfirmXmlPDF: downloadConfirmXmlPDF,

      getXmlInbox: getXmlInbox,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'date',
      };

      return filterCriteria;
    }

    function getConfirmXmls(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
              totalAmounts: response.totalAmounts,
              sumItems: response.sumItems,
            };
          } else {
            return {
              items: response,
              sumItems: response.sumItems,
            };
          }
        },
        {}
      );
    }

    function getConfirmXml(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    function saveConfirmXml(confirmXml) {
      // , webhookEndPoint
      let method = 'post';
      let url = apiUrl;

      // let webhookUrl = ENV.apiEndpoint + webhookEndPoint;

      if (confirmXml.id) {
        // edit
        method = 'put';
        url += '/' + confirmXml.id;
      }

      function success(response) {
        let msg = confirmXml.id ? 'CONFIRM_XML_MODIFIED' : 'CONFIRM_XML_ADDED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { confirm_xml: confirmXml }, success, failure); // , webhookUrl: webhookUrl
    }

    function createBillFromXml(confirmXml) {
      // , webhookEndPoint
      let method = 'post';
      let url = apiUrl + '/create_bill_from_xml';

      // let webhookUrl = ENV.apiEndpoint + webhookEndPoint;

      function success(response) {
        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { confirm_xml: confirmXml, skip_check_role: true },
        success,
        failure
      ); // , webhookUrl: webhookUrl
    }

    function deleteConfirmXml(confirmXml, successCallback) {
      let url = apiUrl + '/' + confirmXml.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        { company_id: confirmXml.company_id },
        function () {
          let params = {
            title: 'DELETE_CONFIRM_XML',
            itemName: confirmXml.confirm_xml_number,
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'CONFIRM_XML_DELETED',
            company_id: confirmXml.company_id,
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeConfirmXmlStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function downloadConfirmXmlPDF(confirmXml, lang) {
      var apiUrlPdf = apiUrl + '/' + confirmXml.id + '/confirm_xml_pdf.pdf';

      return RestResource.request(
        'get',
        apiUrlPdf,
        { company_id: confirmXml.company_id, lang: lang },
        function (response) {
          let blobVar = new Blob([response.data], { type: 'application/pdf' });

          FileSaver.saveAs(
            blobVar,
            $translate('CONFIRM_XML') + ' ' + confirmXml.confirm_xml_products_number + '.pdf'
          );
        },
        function () {}
      );
    }

    function getXmlInbox(company_id) {
      let url = environment.apiEndpoint + 'cron_jobs/' + company_id;

      return RestResource.request(
        'get',
        url,
        {},
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
